import * as Api from '@ViewModels';
import { useTagsQuery } from '../../../../../queries/Tag/useTagsQuery';

const PageSize = 25;
const AlphabeticalSort: Api.ISortDescriptor = { sort: 'asc', sortBy: 'name' };

export function useAllTagsList({
	excludedTagNames,
	impersonationContext,
	query,
}: {
	excludedTagNames?: ReadonlySet<string>;
	impersonationContext?: Api.IImpersonationContext;
	query?: string;
}) {
	const tagsQuery = useTagsQuery({
		impersonationContext,
		pageSize: PageSize,
		query: query || undefined,
		sortDescriptor: AlphabeticalSort,
	});
	const tags = (tagsQuery.data?.pages.flatMap(page => page.values) ?? []).filter(
		tag => !excludedTagNames?.has(tag.name)
	);
	return {
		fetchNextPage: tagsQuery.fetchNextPage,
		hasNextPage: tagsQuery.hasNextPage,
		isFetchingNextPage: tagsQuery.isFetchingNextPage,
		refetch: tagsQuery.refetch,
		status: tagsQuery.status,
		tags,
	};
}
